
import { LOGOUT, SIGNUP_SUCCESS } from "./auth.types";

export const signupApi =()=>(
   
{type:SIGNUP_SUCCESS}
  
)



export let logout =()=>(
   {type:LOGOUT}
)